import { useNavigate, useSearchParams } from "react-router-dom";

import { DrawerContextProvider } from "shared/contexts/DrawerContext";
import { DropdownMultiSelectContextProvider } from "shared/contexts/DropdownMultiSelectContext";
import Modal from "shared/components/feedback/modals/MasterModal";
import PageWrapper from "app/components/PageWrapper";
import ProjectsForm from "features/admin/projects/ProjectsForm";
import ProjectsTable from "features/admin/projects/ProjectsTable";
import { ServerSidePaginationContextProvider } from "shared/contexts/ServerSidePaginationContext";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const action = searchParams.get("action");
    const id = searchParams.get("id");

    const onClose = () => {
        navigate(".", { replace: true });
    };

    if (action === "add") {
        return (
            <Modal
                title="Add Project"
                onRequestClose={onClose}
                stickyAction={true}
            >
                <ProjectsForm key="new" onClose={onClose} />
            </Modal>
        );
    }

    const parsedId = Number.parseInt(id);

    if (action === "edit" && !Number.isNaN(parsedId)) {
        return (
            <Modal
                title="Edit Project"
                onRequestClose={onClose}
                stickyAction={true}
            >
                <ProjectsForm
                    projectIdToEdit={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};

const Projects = () => {
    return (
        <PageWrapper
            title="Projects"
            menuOptions={[{ children: "Admin", to: "/admin" }]}
        >
            <ServerSidePaginationContextProvider>
                <DropdownMultiSelectContextProvider>
                    <DrawerContextProvider>
                        <FormPresenter />
                        <ProjectsTable />
                    </DrawerContextProvider>
                </DropdownMultiSelectContextProvider>
            </ServerSidePaginationContextProvider>
        </PageWrapper>
    );
};

export default Projects;
